<template>
  <div class="py-2 px-4 profile-body">
    <v-row class="align-center">
      <!-- BUTTONS BLOCK -->
      <v-col cols="12" class="d-flex align-center pt-0 py-0">
        <v-chip
          v-if="!$store.state.duplicateContactMode.active"
          class="px-0 mr-2"
          color="transparent"
          @click="homepage()"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-chip>
        <h2 class="d-none d-inline-block mr-2 pt-1">
          Nouveau Client
        </h2>
      </v-col>
      <!-- END BUTTONS -->
    </v-row>

    <v-alert v-if="errors.length" type="error" dismissible @input="clearErrors">
      <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
    </v-alert>

    <v-alert v-if="warnings.items.length" text icon="mdi-alert-outline" type="warning">
      <div v-for="(warning, index) in warnings.items" :key="index" v-html="warning"></div>
    </v-alert>

    <v-alert v-if="successes.length" type="success">
      <div v-for="(success, index) in successes" :key="index">{{ success }}</div>
    </v-alert>

    <v-card class="user-card rounded-lg mt-4" outlined tile elevation="0">
      <v-card-title>
        <span class="subtitle-2 bold">Contact</span> <v-spacer />
      </v-card-title>
      <v-divider />

      <v-card-text class="d-flex flex-wrap grey lighten-4">
        <NewCustomerForm
          ref="newCustomerForm"
          :content="content"
          :valid.sync="valid"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />

        <v-btn
          :disabled="loading"
          color="info"
          elevation="0"
          class="mr-2 px-4"
          @click="clear()"
        >
          <v-icon>mdi-broom</v-icon><span class="ml-2">Effacer</span>
        </v-btn>
        <v-btn
          :disabled="loading"
          color="secondary"
          elevation="0"
          class="mr-2 px-4"
          @click="trySave()"
        >
          <v-icon>mdi-content-save</v-icon><span class="ml-2">Enregistrer</span>
        </v-btn>
      </v-card-actions>
    </v-card>

    <ExistingAccountModal/>

  </div>
</template>

<script>
import NewCustomerForm from '@/components/forms/NewCustomerForm';
import ExistingAccountModal from '@/components/forms/ExistingAccountModal';

import { utils, requests } from '@/mixins/index';

import { EventBus } from '../../mixins';

export default {
  name: 'NewCustomer',
  components: { NewCustomerForm, ExistingAccountModal },
  mixins: [utils, requests],
  data () {
    return {
      valid: false,
      loading: false,
      errors: [],
      successes: [],
      warnings: {
        valid: true,
        items: []
      },
      content: {}
    };
  },
  created () {
    this.content = this.defaultContent();

    // If is creating a contact based on
    if (this.$store.state.duplicateContactMode.active) {
      Object.keys(this.content).forEach(key => {
        this.content[key] = this.$store.state.duplicateContactMode.customer[key];
      });

      const { contexts } = this.$store.state.duplicateContactMode.customer;
      if (contexts.length === 1) {
        this.content.context = contexts[0].value;
      }

      this.content.gender = null;
      this.content.firstname = null;
      this.content.birth_date = null;
    }
  },
  mounted () {
    EventBus.$on('change-warnings', newWarnings => {
      this.clearAlerts();
      this.warnings.valid = newWarnings.valid;
      this.warnings.items = newWarnings.warnings;
    });
    EventBus.$on('change-errors', newErrors => {
      this.errors = newErrors;
    });
    EventBus.$on('save', () => {
      this.save();
    });
  },
  beforeDestroy () {
    EventBus.$off('change-warnings');
    EventBus.$off('change-errors');
    EventBus.$off('save');
  },
  methods: {
    clearAlerts () {
      this.loading = false;
      this.successes = [];
      this.errors = [];
    },
    clear () {
      this.clearAlerts();
      this.$refs.newCustomerForm.resetValidation();
      this.content = this.defaultContent();
    },
    async trySave() {
      await this.$refs.newCustomerForm.validate();
    },
    async save () {
      this.clearAlerts();
      // Error message launched on validation
      if (this.valid) {
        // if (!this.warnings.valid) {
        //   this.warnings.items = [];
        //   this.errors = ['Un client avec cet email existe déjà'];
        //   return;
        // }
        this.loading = true;

        this.content.workspace = this.$store.state.brand;
        const customerResponse = await this.createCustomer(this.content);

        if (!customerResponse.success || !(customerResponse.data && customerResponse.data.success)) {
          this.errors = [(customerResponse.data && customerResponse.data.message) || 'Error in the request.'];
          this.loading = false;
          return;
        }

        const { uuid } = customerResponse.data.customer;

        if (this.$store.state.addContactMode && this.$store.state.addContactMode.active) {
          this.$store.commit('setAddContactMode', {
            active: false,
            contactToAdd: customerResponse.data.customer
          });

          this.$router.push({
            name: 'Customer',
            params: { uuid: this.$store.state.addContactMode.customer_uuid }
          });

          this.loading = false;
          return;
        }

        if (this.$store.state.duplicateContactMode.active) {
          const customerUuid = this.$store.state.duplicateContactMode.customer.uuid;
          const contactUuid = uuid;
          this.$store.commit('setDuplicateContactMode', {
            active: false,
            customer: null
          });

          await this.addContactoCustomerRequest(customerUuid, contactUuid);
        }
        this.$router.push({ name: 'Customer', params: { uuid: uuid } });

        this.loading = false;
      }
    },
    clearErrors () {
      this.errors = [];
    }
  }
};
</script>
